import React, { useState } from 'react';
import { MapPin, Phone, Mail, Linkedin, Send } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { toast } from 'sonner';
import ContactForm from "./ContactForm";

// import { base44 } from '@/api/base44Client';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    organization: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // Mock sending email locally
      console.log('Contact form submitted:', formData);
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1000));
      setIsSubmitted(true);
      setFormData({ name: '', email: '', organization: '', message: '' });
      toast.success('Message sent successfully!');
    } catch (error) {
      toast.error('Failed to send message. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <section id="contact" className="py-12 sm:py-16 md:py-24 bg-secondary/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-12 md:mb-16">
          <h2 className="font-heading font-bold text-3xl sm:text-4xl md:text-5xl text-foreground mb-4">
            Contact Us
          </h2>
        </div>

        <div className="grid gap-2 sm:gap-6 md:gap-8 max-w-full mx-auto lg:grid-cols-[minmax(0,1fr)_minmax(0,743px)] items-start">
          {/* Contact Information */}
          <div className="space-y-8">
            <div>
              <h3 className="font-heading font-semibold text-2xl text-foreground mb-6">
                Corporate Office
              </h3>
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <MapPin className="h-6 w-6 text-accent flex-shrink-0 mt-1" />
                  <div>
                    <p className="font-semibold text-foreground mb-1">Brion Enterprises LLP</p>
                    <p className="text-muted-foreground leading-relaxed">
                      1017, Chandak Unicorn<br />
                      Andheri West, Mumbai<br />
                      Maharashtra, India
                    </p>
                  </div>
                </div>

                <div className="flex items-center gap-4">
                  <Phone className="h-6 w-6 text-accent flex-shrink-0" />
                  <a
                    href="tel:+917718078098"
                    className="text-muted-foreground hover:text-foreground transition-colors"
                  >
                    +91 77180 78098
                  </a>
                </div>

                <div className="flex items-center gap-4">
                  <Mail className="h-6 w-6 text-accent flex-shrink-0" />
                  <a
                    href="mailto:mail@brionenterprises.in"
                    className="text-muted-foreground hover:text-foreground transition-colors"
                  >
                    mail@brionenterprises.in
                  </a>
                </div>

                <div className="flex items-center gap-4">
                  <Linkedin className="h-6 w-6 text-accent flex-shrink-0" />
                  <a
                    href="https://www.linkedin.com/company/brionenterprises/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-muted-foreground hover:text-foreground transition-colors"
                  >
                    Brion Enterprises LLP
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="space-y-8">
            <ContactForm />
          </div>
        </div>
        <div className="text-center mb-10 sm:mb-12 md:mb-16 pt-8" >
          <div className="lg:mt-0">
            <h3 className="font-heading font-semibold text-2xl text-foreground mb-6 text-center">
              Our Location
            </h3>
            <div className="overflow-hidden rounded-3xl border border-border shadow-sm">
              <iframe
                title="Chandak Unicorn Location"
                src="https://maps.google.com/maps?q=1017%20Chandak%20Unicorn%20Andheri%20West%20Mumbai%20Maharashtra%20India&t=&z=15&ie=UTF8&iwloc=&output=embed"
                width="100%"
                height="260"
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}